module.exports = "/static/media/mastercard.15144278.png";